import React from 'react';
import { Button, Popconfirm, Space, Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { iSiteResponse } from '../../../Types/Types';
import { FaPen, FaTrash } from 'react-icons/fa';
import axios, { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import api from '../../../helpers/axios';

type TableProps = {
    Data: iSiteResponse[];
    setData: Function;
    edit: Function;
};

export default function TableSite({ Data, setData, edit }: TableProps) {
    async function startDelete(id: string) {
        await api.delete(`/sites/${id}`)
            .then((response) => {
                toast.success("Usuário excluido com Sucesso !")
                // console.log(response);
                setData(Data.filter(item => Number(item._id) !== Number(id)));
            })
            .catch((error: AxiosError) => {
                console.error(error);
                toast.error(error.message);
            });
    }
    const columns: ColumnsType<iSiteResponse> = [
        {
            title: 'Nome Site',
            dataIndex: 'nome',
            key: 'nome',
            width: '5%',
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            width: '5%',
            render: (_, { ativo }) => (
                <>
                    <Tag color={ativo ? "#87d068" : "volcano"}>
                        {ativo ? "Ativo" : "Inativo"}
                    </Tag>
                </>
            ),
        },
        {
            title: 'Empresa',
            dataIndex: 'idEmpresa.nome',
            key: 'empresa',
            width: '10%',
            render: (_, { idEmpresa }) => (
                <>
                    {idEmpresa.nome}
                </>
            ),
        },
        {
            title: 'Modulos',
            dataIndex: 'idModulos.nome',
            key: 'modulo',
            width: '10%',
            render: (_, { idModulos }) => (
                <>
                    {idModulos.map(item => {
                       return <Tag color={item.cor}> {item.nome} </Tag>
                    })}
                </>
            ),
        },
        {
            title: '',
            key: 'action',
            width: '1%',
            render: (_, row) => (
                <Space size="middle">
                    <Button type="text" onClick={() => edit(row._id)}><FaPen /></Button>
                    <Popconfirm
                        title="Deletar Site !"
                        description="Tem certeza que deseja deletar ?"
                        onConfirm={() => startDelete(row._id)}
                        // onCancel={handleOpenCloseModalConfirm}
                        okText="Sim"
                        cancelText="Não"
                    >
                        <Button type="text" danger><FaTrash /></Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];
    return (
        <Table columns={columns} dataSource={Data} />
    )
}
